<template>
  <div class="quick-notification-item d-flex flex-row p-2">
    <div class="d-flex justify-content-center" style="width: 4rem">
      <img
        style="width: 3.5rem; height: 3.5rem"
        :src="`/providerTransaction/${element.transactionPaymentMethodId}.svg`"
      />
    </div>
    <div
      class="d-flex flex-column flex-fill"
      style="width: 1%; margin-left: 0.5rem"
    >
      <div>
        <span v-if="element.transactionAmount">
          <span>You have successfully deposited</span>
          <span style="font-weight: 500">
            ${{ element.transactionAmount }}.&nbsp;
          </span>
        </span>
        <span
          v-if="
            element.transactionIrenderPoint &&
            element.transactionIrenderPoint !== 0
          "
          style="font-weight: 500"
        >
          {{ element.transactionIrenderPoint }} iRp
        </span>
        <span
          v-if="
            element.transactionBonusPoint && element.transactionBonusPoint !== 0
          "
        >
          <span
            v-if="
              element.transactionIrenderPoint &&
              element.transactionIrenderPoint !== 0
            "
            >and</span
          >
          <span style="font-weight: 500">
            {{ element.transactionBonusPoint }} Bp
          </span>
        </span>
        <span>has been added to your account</span>
      </div>
      <div style="font-size: 0.8rem; color: #42a5f5">
        {{ element.createdAt | pretyDateUtcToLocal }}
      </div>
      <div class="mt-2 mb-1">
        <el-button
          @click="goToDetailInvoice"
          :title="`Transaction ID :${element.transactionCode}`"
          style="font-family: Montserrat; width: 7.5rem"
          size="small"
        >
          Invoice
        </el-button>
      </div>
    </div>
    <div
      v-if="!element.read"
      class="
        d-flex
        flex-row
        align-items-center
        justify-content-center
        ml-1
        mr-1
      "
    >
      <div
        style="
          height: 12px;
          width: 12px;
          border-radius: 1rem;
          background-color: forestgreen;
        "
      ></div>
    </div>
  </div>
</template>

<script>
// Extend
import baseNotificationsService from "@/scripts/notifications/baseNotificationsService";

export default {
  extends: baseNotificationsService,

  props: {
    element: {
      type: Object,
      default: null,
    },
  },

  methods: {
    //#region Go to detail invoice
    goToDetailInvoice() {
      this.$root.$emit("bv::hide::popover");
      this.pushUrl(this.routeUrl.PAYMENT_MANAGEMENT);
      this.markStatus(this.element.id);
    },
    //#endregion
  },
};
</script>